var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-huddle-new float-right relative tw-flex tw-flex-1 tw-justify-end"},[_c('i',{staticClass:"fa fa-search hover-opacity",on:{"click":_vm.toggleSearch}})])
}
var staticRenderFns = []

export { render, staticRenderFns }